import * as React from "react";

/**
 * Lead Sniper crosshair / scope icon. Lucide-compatible API (accepts `size`,
 * `className`, `strokeWidth`) so it drops into the sidebar + Coming Soon panel
 * exactly like a lucide icon. Stroke uses currentColor.
 */
export function LeadSniperIcon({
  size = 24,
  strokeWidth = 2,
  className,
  ...props
}: {
  size?: number;
  strokeWidth?: number;
  className?: string;
} & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* scope rings */}
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="4" />
      {/* crosshair ticks */}
      <line x1="12" y1="1.5" x2="12" y2="5.5" />
      <line x1="12" y1="18.5" x2="12" y2="22.5" />
      <line x1="1.5" y1="12" x2="5.5" y2="12" />
      <line x1="18.5" y1="12" x2="22.5" y2="12" />
      {/* center dot */}
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}
